export default __webpack_public_path__ + "static/media/circle-plus-solid.fde92418.svg";